module.exports = __webpack_public_path__ + "static/office_1-664dc4d8db032adae5df8a7c0fb9d93d.png";